import React from "react";

function CalibrationModal(props) {
  const {
    show,
    onComplete,
    onSkip,
    proctorOrigin,
    proctorPath = "/calibration",
    token,
    sessionId,
    apiBaseUrl,
    examContext,
    constraints,
  } = props;

  const iframeRef = React.useRef(null);
  const [ready, setReady] = React.useState(false);
  const initSentRef = React.useRef(false);

  const payload = React.useMemo(() => ({
    apiBaseUrl,
    token,
    sessionId,
    examContext,
    constraints,
    mode: "calibration",
  }), [apiBaseUrl, token, sessionId, examContext, constraints]);

  const postInit = React.useCallback(() => {
    if (!iframeRef.current || initSentRef.current) return;
    initSentRef.current = true;
    console.log('[CalibrationModal] 📤 Sending init message to calibration iframe:', {
      proctorOrigin,
      apiBaseUrl: payload.apiBaseUrl,
      sessionId: payload.sessionId,
      mode: payload.mode,
      iframeSrc: `${proctorOrigin}${proctorPath}`,
    });
    iframeRef.current.contentWindow?.postMessage({ type: "proctor:init", payload }, proctorOrigin);
  }, [payload, proctorOrigin]);

  React.useEffect(() => {
    function handleMessage(e) {
      // if (e.origin !== proctorOrigin) return;
      const data = e.data || {};
      if (data.type === "proctor:ready") {
        console.log('[CalibrationModal] received proctor:ready');
        setReady(true);
        return;
      }
      if (data.type === "proctor:calibration-complete") {
        console.log('[CalibrationModal] received calibration-complete');
        onComplete?.(data.payload);
        return;
      }
      if (data.type === "proctor:calibration-skip") {
        console.log('[CalibrationModal] received calibration-skip');
        onSkip?.();
        return;
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [proctorOrigin, onComplete, onSkip]);

  React.useEffect(() => {
    if (!show) {
      initSentRef.current = false;
      return;
    }
    const iframe = iframeRef.current;
    if (!iframe) return;
    const handleLoad = () => {
      console.log('[CalibrationModal] iframe loaded');
      setTimeout(postInit, 100);
    };
    iframe.addEventListener("load", handleLoad);
    return () => iframe.removeEventListener("load", handleLoad);
  }, [show, postInit]);

  // Only render when shown to prevent multiple iframes
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        background: "#000",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <iframe
        ref={iframeRef}
        title="Proctor Calibration"
        src={`${proctorOrigin.replace(/\/$/, '')}${proctorPath}`}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          display: "block",
        }}
        allow="camera"
      />
    </div>
  );
}

export default CalibrationModal;

